import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "./Error.js";

var r = /*#__PURE__*/function () {
  function r(t, _r) {
    var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

    _classCallCheck(this, r);

    this.major = t, this.minor = _r, this._context = o;
  }

  _createClass(r, [{
    key: "lessThan",
    value: function lessThan(t, _r2) {
      return this.major < t || t === this.major && this.minor < _r2;
    }
  }, {
    key: "since",
    value: function since(t, _r3) {
      return !this.lessThan(t, _r3);
    }
  }, {
    key: "validate",
    value: function validate(_r4) {
      if (this.major !== _r4.major) {
        var o = this._context && this._context + ":",
            s = this._context && this._context + " ";
        throw new t(o + "unsupported-version", "Required major ".concat(s, "version is '").concat(this.major, "', but got '${version.major}.${version.minor}'"), {
          version: _r4
        });
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new r(this.major, this.minor, this._context);
    }
  }], [{
    key: "parse",
    value: function parse(o) {
      var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      var _o$split = o.split("."),
          _o$split2 = _slicedToArray(_o$split, 2),
          e = _o$split2[0],
          i = _o$split2[1],
          n = /^\s*\d+\s*$/;

      if (!e || !e.match || !e.match(n)) {
        throw new t((s && s + ":") + "invalid-version", "Expected major version to be a number, but got '${version}'", {
          version: o
        });
      }

      if (!i || !i.match || !i.match(n)) {
        throw new t((s && s + ":") + "invalid-version", "Expected minor version to be a number, but got '${version}'", {
          version: o
        });
      }

      var a = parseInt(e, 10),
          h = parseInt(i, 10);
      return new r(a, h, s);
    }
  }]);

  return r;
}();

export { r as Version };